<template>
  <div class="box">
    <div class="headline">
      <div class="top">Step 1 of 5</div>
      Users and authentication
      </div>
    <b-form>
      <b-form-group description="Will the service have users that can sign up and log in?">
        <b-form-checkbox v-model="useAuth">Support authentication</b-form-checkbox>
      </b-form-group>

      <div v-if="useAuth">
        <p>
          A <code>users</code> Django app will be created with <code>users.User</code> model
          using the preferred authentication method.
        </p>
        <b-form-group label="Authentication method" description="What to use for user authentication">
          <b-form-select v-model="auth.user_model" :options="USER_MODEL_OPTIONS"></b-form-select>
        </b-form-group>

        <b-form-group description="Can the new users sign up by themselves?">
          <b-form-checkbox v-model="auth.allow_signup">Allow signup</b-form-checkbox>
        </b-form-group>

        <b-form-group description="Can admins use REST API to create and manage users?">
          <b-form-checkbox v-model="auth.admin_crud_api">Enable users CRUD API</b-form-checkbox>
        </b-form-group>

        <b-form-group description="Do you want to use Django's auto-generated admin interface?">
          <b-form-checkbox v-model="djangoAdmin">Enable Django Admin interface</b-form-checkbox>
        </b-form-group>
      </div>

      <div class="button-row">
        <div></div>
        <b-button variant="primary" @click="$emit('next', exportData)">Next &rarr;</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { USER_MODEL_OPTIONS } from '../../helpers/constants'

export default {
  name: 'Auth',

  props: {
    recipe: {type: Object, required: true}
  },

  data () {
    const a = this.recipe.auth

    return {
      useAuth: !!a,
      auth: {
        user_model: a ? a.user_model : 'django',
        allow_signup: a ? a.allow_signup : false,
        admin_crud_api: a ? a.admin_crud_api : false
      },
      djangoAdmin: this.recipe.django_admin,

      USER_MODEL_OPTIONS
    }
  },

  computed: {
    exportData () {
      return {
        auth: this.useAuth ? this.auth : null,
        djangoAdmin: this.djangoAdmin
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wizard/Auth.vue